import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { useLang } from '../../context/LangContext'
import { setLangInLocalStorage } from '../../utils/lang'
import { useGetTranslatedValue } from '../../lang/lang'

const LangToggleBox = () => {
  const { lang, setLang } = useLang()
  const translate = useGetTranslatedValue()
  const handleChange = (event) => {
    setLang(event.target.value)
    setLangInLocalStorage(event.target.value)
  }
  const options = [
    { text: '日本語', value: 'ja' },
    { text: 'English（試験運用中）', value: 'en' }
  ]

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small" variant="outlined">
      <Select labelId="demo-select-small-label" id="demo-select-small" value={lang} onChange={handleChange}>
        {options.map((op, i) => (
          <MenuItem key={i} value={op.value}>
            {op.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default LangToggleBox
